// import { verify2faCode } from '@basqet-dashboard/common/api';
import { ReactComponent as BackArrow } from '@basqet-dashboard/common/assets/icons/back-arrow.svg';
import { Button, FormInput } from '@basqet-dashboard/common/components/';
import { formatErrorMessage, twoFASchema } from '@basqet-dashboard/common/utils';
import { yupResolver } from '@hookform/resolvers/yup';
import PropTypes from 'prop-types';
import React from 'react';
import { useForm } from 'react-hook-form';

const TwoFactorAuth = ({ setTransactionInfo, setCurrentStage }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isDirty, isValid }
  } = useForm({ mode: 'onChange', resolver: yupResolver(twoFASchema) });

  const onSubmit = async (body) => {
    try {
      setTransactionInfo((currentTransactionInfo) => {
        return {
          ...currentTransactionInfo,
          otp: body?.code
        };
      });

      setCurrentStage('PROCESS_PAYOUT');
    } catch (error) {
      formatErrorMessage(error);
    }
  };
  return (
    <div className="card">
      <button className="payout__back-btn" onClick={() => setCurrentStage('CONFIRM_TRANSACTION')}>
        <BackArrow />
      </button>
      <div className="card__header">
        <h3 className="card__title">
          2 Factor <span className="text-cursive">Authentication</span>
        </h3>
      </div>
      <p className="card__description">Please enter the access code from your Authenticator App</p>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormInput
          label="2FA access code"
          placeholder="Enter your code here"
          name="code"
          type="tel"
          error={errors.code && errors.code.message}
          register={register('code')}
        />
        <Button disabled={!isDirty || !isValid} isFull type="submit" isLoading={isSubmitting}>
          Continue
        </Button>
      </form>
    </div>
  );
};
TwoFactorAuth.propTypes = {
  setCurrentStage: PropTypes.func,
  setTransactionInfo: PropTypes.func
};

export { TwoFactorAuth };
